import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import firebase from 'firebase/app'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import rootReducer from './store/reducers/rootReducer'
import 'firebase/firestore'
import { createStore, applyMiddleware } from 'redux'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { createFirestoreInstance } from 'redux-firestore'

const firebaseConfig = {
  apiKey: "AIzaSyDEA6yi9p3QlNGHzoWRshVTJXvydad-SA0",
  authDomain: "teachourteachers-369a6.firebaseapp.com",
  databaseURL: "https://teachourteachers-369a6.firebaseio.com",
  projectId: "teachourteachers-369a6",
  storageBucket: "teachourteachers-369a6.appspot.com",
  messagingSenderId: "235934848743",
  appId: "1:235934848743:web:798c8b4579cb2b4d0a7442",
  measurementId: "G-LX9H0WNC45"
};

// react-redux-firebase config
const rrfConfig = {
  useFirestoreForProfile: true,
}

// Initialize firebase instance
firebase.initializeApp(firebaseConfig)

// Initialize other services on firebase instance
firebase.firestore() // <- needed if using firestore

// Create store with reducers and initial state
const initialState = {}
const store = createStore(rootReducer, initialState, applyMiddleware(thunk))

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance // <- needed if using firestore
}

ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <ReactReduxFirebaseProvider {...rrfProps}>
          <App />
        </ReactReduxFirebaseProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
serviceWorker.register();
